var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08398 0C2.32256 0 0.0839844 2.23857 0.0839844 5V14.9773C0.0839844 17.7388 2.32256 19.9773 5.08398 19.9773H15.0613C17.8227 19.9773 20.0613 17.7388 20.0613 14.9773V5C20.0613 2.23858 17.8228 0 15.0613 0H5.08398ZM15.105 5.32296C15.5357 4.89248 16.2343 4.89221 16.6645 5.32296C17.0952 5.75368 17.0952 6.45222 16.6645 6.88268L8.86601 14.6814C8.65077 14.8969 8.36826 15.0045 8.086 15.0045C7.80374 15.0045 7.5215 14.8966 7.30626 14.6814L3.40705 10.7822C2.9763 10.3514 2.9763 9.6532 3.40705 9.22245C3.8378 8.7917 4.53604 8.7917 4.96679 9.22245L8.0863 12.3419L15.105 5.32296Z",
    fill: "#1BA929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckbox);
export default __webpack_public_path__ + "static/media/icon_checkbox.1ac472ff49d91b8df80f80b84628e463.svg";
export { ForwardRef as ReactComponent };